import React from 'react';
import './Testimonials.scss';

const LOGOS = ['Logo 1', 'Logo 2', 'Logo 3', 'Logo 4', 'Logo 5'];

const QUOTES = [
  { body: 'Testimonial placeholder — drop in a real quote from a youth sports or tournament organizer.', attrib: 'Name, role, organization' },
  { body: 'Testimonial placeholder — a school or district athletic director on cost predictability.', attrib: 'Name, role, organization' },
  { body: 'Testimonial placeholder — a college or community event organizer on fill speed.', attrib: 'Name, role, organization' },
];

const Testimonials = () => (
  <section className="pl-social">
    <div className="pl-social__inner">
      <div className="pl-social__eyebrow">Trusted by organizers across youth sports, schools, colleges and community events</div>
      <div className="pl-social__logos">
        {LOGOS.map((l) => (
          <div key={l} className="pl-social__logo">{l}</div>
        ))}
      </div>
      <div className="pl-social__quotes">
        {QUOTES.map((q, i) => (
          <div key={i} className="pl-social__quote">
            <p className="pl-social__quote-body">{q.body}</p>
            <div className="pl-social__quote-attrib">{q.attrib}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
